import RewardsProgress from '../../presentation/rewardProgress/RewardsProgress';
import { useSelector } from 'react-redux';

function RewardsProgressContainer() {
	const currentUser = useSelector((state) => state.user.currentUser);
	const tieredRewardsCampaign =
		currentUser?.company?.recognitionSettings?.tieredRewardsCampaign || [];

	return (
		<>
			{tieredRewardsCampaign.length > 0 ? (
				<RewardsProgress
					currentUser={currentUser}
					tiers={tieredRewardsCampaign}
				/>
			) : null}
		</>
	);
}

export default RewardsProgressContainer;
